import { createFileRoute } from '@tanstack/react-router'
import React from "react";
import TournamentsChoiceView from "../../tournaments/TournamentsChoiceView.tsx";

export const Route = createFileRoute('/_app/tournaments-choice')({
  component: RouteComponent,
})

function RouteComponent() {
  return <TournamentsChoiceView />
}
